import type { PointerEvent } from "react";

export function setPointerGlow(event: PointerEvent<HTMLElement>) {
  const element = event.currentTarget;
  const rect = element.getBoundingClientRect();
  const x = ((event.clientX - rect.left) / rect.width) * 100;
  const y = ((event.clientY - rect.top) / rect.height) * 100;

  element.style.setProperty("--x", `${x}%`);
  element.style.setProperty("--y", `${y}%`);
}
